







import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { CountUp } from 'countup.js'

@Component({})
export default class StatNumber extends Vue {
  @Prop()
  title: string

  @Prop()
  number: number

  mounted() {
    this.startCountup()
  }

  @Watch('number')
  startCountup() {
    const countUp = new CountUp((this.$refs as any).number, this.number)
    const countUpInvisible = new CountUp((this.$refs as any).invisible, this.number, { duration: 0 })

    countUp.start()
    countUpInvisible.start()
  }
}
